
import type { ReactNode } from "react";
import React from "react";
import type { MessageFormatElement } from "react-intl";
import { IntlProvider } from "react-intl";
import { useConfigStore } from "./store/store";

interface I18nProps {
    children: ReactNode;
}

export const I18n: React.FC<I18nProps> = ({ children }) => {
    const { translations, language } = useConfigStore();

    return (
        <IntlProvider
            messages={translations as Record<string, string> | Record<string, MessageFormatElement[]>}
            locale={language}
            key={language}
        >
            {children}
        </IntlProvider>
    );
};
